// extracted by mini-css-extract-plugin
module.exports = {"header":"header_header__pwrbs","mobileHeaderTitle":"header_mobileHeaderTitle__D5Luo","logoWrapper":"header_logoWrapper__tSXEH"};